/**
 * @param key
 * @param params
 */
export function getTranslationForDynamicErrors(key: string, params: string[]) {
    const currentLang = (window as any).uiLanguage;

    // Define translations
    const translations = {
        'en-GB': {
            required: 'requires a value',
            minExclusive: 'must be a value greater than {0}.',
            minInclusive: 'must be a value greater than or equal to {0}.',
            maxExclusive: 'must be a value less than {0}.',
            maxInclusive: 'must be a value less than or equal to {0}.',
            length: 'must have a total length of {0}.',
            maxLength: 'must have a total length less than or equal to {0}.',
            minLength: 'must have a total length greater than or equal to {0}.',
            pattern: 'must match a RegExp pattern of {0}.',
            maxDecimalPlaces: 'must not have more than {0} decimal places.',
            enterInfoBlank: 'Please enter info in the blank "',
            removeThis: 'Remove this "',
            other: ' Other ',

            BL: 'must be a boolean (true/false).',
            INT: 'must be an integer number.',
            REAL: 'must be a decimal number.',
            ST: 'must be a string value.',
            TX: 'must be a text value.',
            BIN: 'must be a binary value.',
            DT: 'must be a date value.',
            DTM: 'must be a date and time value.',
            TM: 'must be a time value.',
            RTO: 'must be a ratio value.',
            QTY: 'must be a decimal number.',
            NR: 'must be two numeric values separated by a ^. One value can be omitted, but not the ^.',
            YEAR: 'must be a numeric value of year.',
            MONTH: 'must be a numeric value of month.',
            DAY: 'must be a numeric value of day.',
            URL: 'must be a valid URL.',
            EMAIL: 'must be a valid email address.',
            PHONE: 'must be a valid phone number.',
        },
        'de-DE': {
            required: 'erfordert einen Wert',
            minExclusive: 'muss größer als {0} sein.',
            minInclusive: 'muss größer oder gleich {0} sein.',
            maxExclusive: 'muss kleiner als {0} sein.',
            maxInclusive: 'muss kleiner oder gleich {0} sein.',
            length: 'muss eine Gesamtlänge von {0} haben.',
            maxLength: 'darf eine Gesamtlänge von {0} nicht überschreiten.',
            minLength: 'muss eine Mindestlänge von {0} haben.',
            pattern: 'muss dem Muster {0} entsprechen',
            maxDecimalPlaces: 'darf nicht mehr als {0} Dezimalstellen haben.',
            enterInfoBlank: 'Bitte geben Sie die Informationen in das leere Feld ein "',
            removeThis: 'Entfernen Sie dieses "',
            other: 'Andere',

            BL: 'muss ein Boolean-Wert sein (true/false).',
            INT: 'muss eine ganze Zahl sein.',
            REAL: 'muss eine Dezimalzahl sein.',
            ST: 'muss ein String-Wert sein.',
            TX: 'muss ein Text-Wert sein.',
            BIN: 'muss ein Binärwert sein.',
            DT: 'muss ein Datumswert sein.',
            DTM: 'muss ein Datums- und Zeitwert sein.',
            TM: 'muss ein Zeitwert sein.',
            RTO: 'muss ein Verhältniswert sein.',
            QTY: 'muss eine Dezimalzahl sein.',
            NR: 'muss zwei durch ^ getrennte numerische Werte enthalten. Ein Wert kann weggelassen werden, aber nicht das ^.',
            YEAR: 'muss ein numerischer Jahreswert sein.',
            MONTH: 'muss ein numerischer Monatswert sein.',
            DAY: 'muss ein numerischer Tageswert sein.',
            URL: 'muss eine gültige URL sein.',
            EMAIL: 'muss eine gültige E-Mail-Adresse sein.',
            PHONE: 'muss eine gültige Telefonnummer sein.',
        },
        'ro-RO': {
            required: 'necesită o valoare',
            minExclusive: 'trebuie să fie o valoare mai mare decât {0}.',
            minInclusive: 'trebuie să fie o valoare mai mare sau egală cu {0}.',
            maxExclusive: 'trebuie să fie o valoare mai mică decât {0}.',
            maxInclusive: 'trebuie să fie o valoare mai mică sau egală cu {0}.',
            length: 'trebuie să aibă o lungime totală de {0}.',
            maxLength: 'trebuie să aibă o lungime totală mai mică sau egală cu {0}.',
            minLength: 'trebuie să aibă o lungime totală mai mare sau egală cu {0}.',
            pattern: 'trebuie să corespundă unui model RegExp de {0}.',
            maxDecimalPlaces: 'nu trebuie să aibă mai mult de {0} zecimale.',
            enterInfoBlank: 'Vă rugăm să introduceţi informaţii în spațiul gol "',
            removeThis: 'Elimină asta "',
            other: ' Altele ',

            BL: 'trebuie să fie boolean (adevărat/fals).',
            INT: 'trebuie să fie un număr întreg.',
            REAL: 'trebuie să fie un număr zecimal.',
            ST: 'trebuie să fie o valoare de tip text.',
            TX: 'trebuie să fie o valoare text.',
            BIN: 'trebuie să fie o valoare binară.',
            DT: 'trebuie să fie o valoare de dată.',
            DTM: 'trebuie să fie o dată și o valoare temporală.',
            TM: 'trebuie să fie o valoare de timp.',
            RTO: 'trebuie să fie o valoare a raportului.',
            QTY: 'trebuie să fie un număr zecimal.',
            NR: 'trebuie să fie două valori numerice separate printr-un ^. O valoare poate fi omisă, dar nu ^.',
            YEAR: 'trebuie să fie o valoare numerică a anului.',
            MONTH: 'trebuie să fie o valoare numerică a lunii.',
            DAY: 'trebuie să fie o valoare numerică a zilei.',
            URL: 'trebuie să fie un URL valid.',
            EMAIL: 'trebuie să fie o adresă de e-mail validă.',
            PHONE: 'trebuie să fie un număr de telefon valid.',
        },

        // Add more languages as needed
    };

    // Get the translation for the current language or fall back to English
    let message = (translations[currentLang] && translations[currentLang][key]) || translations['en-GB'][key] || key;

    // Replace parameters
    if (params) {
        for (let i = 0; i < params.length; i++) {
            message = message.replace('{' + i + '}', params[i]);
        }
    }

    return message;
}
